// UK-friendly distance display: shows km with miles bracketed, e.g. "8 km (5 mi)".
// Users in the UK think in miles, so we always surface both.
const KM_PER_MILE = 1.609344;

export function kmToMiles(km) {
  if (km == null || isNaN(km)) return null;
  return km / KM_PER_MILE;
}

/**
 * Format a distance in km as "N km (M mi)".
 * @param {number} km - distance in kilometres
 * @param {object} [opts]
 * @param {number} [opts.km_decimals=0] - decimals for km
 * @param {number} [opts.mi_decimals=0] - decimals for miles
 */
export function formatDistanceKm(km, opts = {}) {
  if (km == null || isNaN(km)) return "";
  const kmDp = opts.km_decimals ?? 0;
  const miDp = opts.mi_decimals ?? 0;
  const mi = km / KM_PER_MILE;
  return `${km.toFixed(kmDp)} km (${mi.toFixed(miDp)} mi)`;
}
